import React from 'react';
import { Typography } from 'fronton-react';

export const getFormHeading = (isMobile: boolean | null) => (
  <Typography variant={isMobile ? 'h2' : 'h1'} color="text-primary">
    Укажите параметры комнаты
  </Typography>
);
